// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

export const wordCloudConstants = {
  wordCloudError:
    'No Non Inclusive Language alerts discovered for the project repositories under this Github organization.',
};
